// Internet do'konlar — xizmat sahifasi kontenti (Innobek)
// Shakl: src/content/services/_shape.js

const uz = {
    meta: {
        title: "Internet do'kon yaratish — narxi 16 mln so'mdan | Innobek",
        description:
            "Internet do'kon (onlayn magazin) yaratish 16 mln so'mdan. Katalog, savat, Payme va Click to'lovlari, yetkazib berish va admin panel. Muddat 20–60 ish kuni.",
        keywords: [
            "internet do'kon",
            "internet do'kon yaratish",
            "onlayn do'kon",
            "internet magazin yaratish",
            "internet do'kon narxi",
            "onlayn savdo sayti",
            "Payme Click ulash",
            "savdo sayti buyurtma",
            "Toshkentda internet do'kon",
        ],
    },
    hero: {
        eyebrow: "Internet do'konlar",
        h1: "Internet do'kon yaratish — 16 mln so'mdan",
        lead:
            "Instagram izohlarida buyurtma yig'ishni to'xtating. O'z internet do'koningiz kechayu kunduz sotadi: katalog, savat, Payme va Click orqali to'lov, yetkazib berish va buyurtmalar hisobi — hammasi bitta tizimda va sizning nazoratingizda.",
        ctaPrimary: "Bepul konsultatsiya olish",
        ctaSecondary: "Narxlarni ko'rish",
        proof: [
            "Payme · Click · Uzum to'lovlari",
            "Admin panel har bir tarifda",
            "Excel va 1C'dan mahsulot import",
            "6 oylik texnik qo'llab-quvvatlash",
        ],
    },
    intro: {
        h: "Internet do'kon nima va u nega marketpleysdan foydaliroq?",
        p: [
            "Internet do'kon — mahsulot katalogi, savat, onlayn to'lov va buyurtmalarni boshqarish tizimi birlashtirilgan sayt. Mijoz mahsulotni topadi, savatga soladi, karta orqali to'laydi va yetkazib berish usulini tanlaydi. Bularning barchasi siz bilan yozishmasdan, kechasi soat ikkida ham bo'lishi mumkin. Buyurtma esa admin panelga tushadi va Telegram'ga xabar keladi.",
            "Bugun ko'p tadbirkor Instagram yoki marketpleys orqali sotadi. Boshlash uchun bu yaxshi yo'l, lekin uchta muammosi bor: har bir buyurtma uchun qo'lda yozishish kerak, komissiya har sotuvdan olinadi va eng muhimi — mijoz bazasi sizniki emas. Platforma ertaga qoidani yoki reklama narxini o'zgartirsa, siz bunga ta'sir qila olmaysiz.",
            "O'z internet do'koningiz esa sizga tegishli aktiv: mijoz ma'lumotlari, sotuv statistikasi, qayta sotuv imkoniyati va Google'dan bepul trafik. Do'kon soatiga o'nlab buyurtmani bir xil sifat bilan qabul qiladi, xodim esa yozishish o'rniga yig'ish va yetkazib berish bilan shug'ullanadi. Aylanma o'sgan sari bu farq sezilarli bo'ladi: qo'lda yuritilgan savdoda xato va yo'qotilgan buyurtmalar soni buyurtma hajmi bilan birga o'sib boradi, tizimda esa o'smaydi.",
            "Innobek do'konni O'zbekiston bozori uchun quradi: Payme, Click va Uzum to'lovlari, kuryer va pochta orqali yetkazib berish, Telegram bildirishnomalari, ikki yoki uch tilli katalog. Mahsulotlarni Excel yoki 1C'dan ko'chirib beramiz — nol mahsulot bilan bo'sh sayt topshirmaymiz. Kod sizga tegishli bo'ladi, hech qanday oylik platforma to'lovi yo'q.",
        ],
    },
    definition: {
        term: "Internet do'kon nima?",
        text:
            "Internet do'kon — mahsulot katalogi, savat, onlayn to'lov, yetkazib berish va buyurtmalarni boshqarish tizimini birlashtirgan sayt. U sotuvchi ishtirokisiz, kunning istalgan vaqtida buyurtma qabul qiladi.",
    },
    included: {
        eyebrow: "Nimalar kiradi",
        h: "Har bir tarifga standart tarzda kiradi",
        sub: "Bular alohida to'lanadigan qo'shimcha emas — bazaviy tarifda ham bor.",
        items: [
            "Bepul konsultatsiya, katalog tuzilmasi va yozma texnik topshiriq",
            "Kategoriya, filtr va qidiruv bilan mahsulot katalogi",
            "Savat, buyurtma rasmiylashtirish va buyurtma tarixi",
            "Admin panel: mahsulot, narx, qoldiq va buyurtmalarni boshqarish",
            "Payme va Click to'lov tizimlarini ulash va sinovdan o'tkazish",
            "Naqd va kuryerga karta orqali to'lash variantlari",
            "Yetkazib berish usullari, hududlari va narxlarini sozlash",
            "Domen, hosting, SSL sertifikati va xavfsiz to'lov oqimi",
            "Telefon va planshetda tekshirilgan moslashuvchan dizayn",
            "Mahsulot sahifalari uchun Schema.org: narx, mavjudlik, reyting",
            "Google Analytics va elektron tijorat (e-commerce) kuzatuvi",
            "Tezlikni optimallashtirish: rasm siqish, lazy-load, kesh",
            "Do'konni boshqarish bo'yicha video-qo'llanma va topshirish uchrashuvi",
            "Ishga tushgandan keyin 6 oylik texnik qo'llab-quvvatlash",
        ],
    },
    benefits: {
        eyebrow: "Nega kerak",
        h: "Internet do'kon biznesga nima beradi",
        sub: "Do'kon — xarajat emas, u sizning ikkinchi sotuvchingiz. Quyida u aniq nimaga ta'sir qiladi.",
        items: [
            {
                t: "Sotuv siz uxlaganda ham davom etadi",
                d: "Buyurtma tunda, dam olish kunida va bayramda ham qabul qilinadi. Mijoz javob kutmaydi: to'laydi va tasdiqni darhol oladi. Amalda buyurtmalarning 20–30 foizi ish vaqtidan tashqarida keladi.",
            },
            {
                t: "Har sotuvdan komissiya to'lamaysiz",
                d: "Marketpleys odatda har sotuvdan sezilarli ulush oladi. O'z do'koningizda faqat ekvayring foizi qoladi. Oylik aylanma 50 mln so'mdan oshsa, tejalgan summa do'kon narxini bir yil ichida qoplaydi.",
            },
            {
                t: "Mijoz bazasi sizda qoladi",
                d: "Telefon raqami, buyurtma tarixi va manzil sizning tizimingizda saqlanadi. Bu qayta sotuv, SMS va Telegram tarqatmalari hamda sodiqlik dasturi uchun asos bo'ladi. Yangi mijoz jalb qilish har doim mavjudini qaytarishdan qimmatroq turadi.",
            },
            {
                t: "Qo'lda ishlash yo'qoladi",
                d: "Buyurtma o'zi qayd etiladi, qoldiq o'zi kamayadi, mijozga tasdiq o'zi yuboriladi. Bitta xodim kuniga 10 ta emas, 100 ta buyurtmani xatosiz yuritadi.",
            },
            {
                t: "Google'dan bepul trafik",
                d: "Har bir mahsulot va kategoriya alohida sahifa — «qishki kurtka narxi» kabi so'rovlar bo'yicha chiqadi. To'g'ri tuzilgan katalog 3–6 oydan keyin reklamasiz trafik bera boshlaydi.",
            },
            {
                t: "Raqamlar asosida qaror",
                d: "Qaysi mahsulot ko'p ko'rilgan-u sotilmagan, qaysi kanal ariza keltirgan, savat qaysi qadamda tashlab ketilgan — analitika ko'rsatadi. Assortiment va reklama shunga qarab sozlanadi.",
            },
            {
                t: "Marketpleysga qaram bo'lmaysiz",
                d: "Platforma qoidani o'zgartirsa yoki kartochkangizni pastga tushirsa, sotuv bir kechada tushib ketishi mumkin. O'z do'koningiz esa sizning qoidalaringiz bo'yicha ishlaydi.",
            },
        ],
    },
    audience: {
        eyebrow: "Kimlar buyurtma qiladi",
        h: "Qanaqa bizneslarga internet do'kon kerak",
        sub: "Mahsulotni takroriy va ko'p miqdorda sotadigan, buyurtmani qo'lda yuritish qiyinlashgan sohalar.",
        items: [
            {
                t: "Kiyim-kechak va poyabzal",
                d: "O'lcham, rang va model bo'yicha filtr, o'lchamlar jadvali, qaytarish shartlari. Mijoz o'zi tanlaydi va savolsiz buyurtma beradi — sotuvchiga murojaat 60 foizga kamayadi.",
            },
            {
                t: "Elektronika va maishiy texnika",
                d: "Batafsil xarakteristikalar, mahsulotlarni taqqoslash, kafolat shartlari va bo'lib to'lash. Bu sohada xaridor uchun eng muhimi — to'liq va aniq ma'lumot.",
            },
            {
                t: "Kosmetika, parfyumeriya va BAD",
                d: "Tarkib, sertifikatlar, ishlatish qoidalari va sharhlar. Qayta xarid yuqori bo'lgani uchun sodiqlik dasturi va qayta buyurtma tugmasi tez o'zini oqlaydi.",
            },
            {
                t: "Oziq-ovqat va yetkazib berish",
                d: "Kategoriya bo'yicha katalog, yetkazib berish vaqti oynasi, minimal buyurtma summasi va bir tugma bilan qayta buyurtma. Tezlik bu yerda konversiyaga to'g'ridan-to'g'ri ta'sir qiladi.",
            },
            {
                t: "Mebel, qurilish va jihozlar",
                d: "Yirik katalog, materiallar hisoblagichi, o'lchov bo'yicha buyurtma va o'rnatish xizmati. Ko'pincha kalkulyator moduli alohida ishlab chiqiladi.",
            },
            {
                t: "B2B va ulgurji savdo",
                d: "Dilerlar uchun shaxsiy kabinet, individual narx ro'yxati, minimal partiya, hisob-faktura va 1C bilan integratsiya. Menejerlar telefon o'rniga tizim bilan ishlaydi.",
            },
        ],
    },
    pricing: {
        eyebrow: "Narxlar",
        h: "Internet do'kon narxi — uchta tarif",
        sub: "Narxlar oshkora. Har bir tarifga admin panel, to'lov tizimlari, ko'p tillilik va qo'llab-quvvatlash kiradi.",
        note:
            "Ko'rsatilgan summalar boshlang'ich oraliq. Yakuniy narx mahsulotlar soni, variatsiyalar va integratsiyalarga qarab bepul konsultatsiyadan keyin tasdiqlanadi. To'lov bosqichma-bosqich: 50% oldindan, 50% topshirishda. To'lov tizimlarining ekvayring komissiyasi alohida — u to'g'ridan-to'g'ri Payme yoki Click'ga to'lanadi va narxga kirmaydi.",
        tiers: [
            {
                name: "Start",
                tagline: "To'liq ishlaydigan internet do'kon",
                price: "16 000 000",
                priceNote: "so'mdan — loyihaga qarab",
                term: "20–30 ish kuni",
                features: [
                    "500 tagacha mahsulot, kategoriya va filtrlar bilan katalog",
                    "Savat, buyurtma rasmiylashtirish va buyurtma tarixi",
                    "Admin panel: mahsulot, narx, kategoriya va buyurtmalar",
                    "Payme va Click orqali onlayn to'lov, naqd va kuryerga karta",
                    "Yetkazib berish usullari va narxlarini sozlash",
                    "Ikki tilli interfeys (o'zbek va rus)",
                    "Telegram'ga yangi buyurtma bildirishnomasi",
                    "Tayyor asosda brendingizga moslashtirilgan dizayn",
                    "Texnik SEO va mahsulot Schema.org belgilash",
                    "Mahsulotlarni Excel'dan ommaviy yuklash",
                    "6 oylik texnik qo'llab-quvvatlash",
                ],
                best: "Instagram yoki marketpleysdan o'z do'koniga o'tayotgan savdo nuqtalari",
            },
            {
                name: "Business",
                tagline: "Individual dizayn va to'liq boshqaruv",
                price: "34 000 000",
                priceNote: "so'mdan — loyihaga qarab",
                term: "40–60 ish kuni",
                features: [
                    "Cheklanmagan mahsulot, murakkab kategoriya daraxti",
                    "Noldan chizilgan individual dizayn, Figma maketi bilan",
                    "Variatsiyali mahsulotlar: o'lcham, rang, komplektatsiya",
                    "Kengaytirilgan admin panel: ombor qoldig'i, ta'minotchilar, hisobotlar",
                    "Aksiya, chegirma, promokod va sodiqlik dasturi",
                    "Mijozning shaxsiy kabineti: buyurtmalar, manzillar, sevimlilar",
                    "Uzum, Payme, Click va bo'lib to'lash tizimlari",
                    "Kuryer xizmatlari bilan integratsiya va buyurtma kuzatuvi",
                    "1C yoki CRM bilan sinxronizatsiya",
                    "Sharh va reyting tizimi, savat tashlab ketilganini eslatish",
                    "Kengaytirilgan SEO: kategoriya matnlari, ichki bog'lanish, tezlik",
                    "Sotuv analitikasi va konversiya maqsadlari",
                    "6 oylik texnik qo'llab-quvvatlash",
                ],
                best: "Katta assortiment, ombor hisobi va doimiy marketing bilan ishlaydigan do'konlar",
                featured: true,
            },
            {
                name: "Enterprise",
                tagline: "Marketpleys va murakkab integratsiyalar",
                price: "Kelishuv",
                priceNote: "asosida — 70 mln so'mdan boshlanadi",
                term: "Loyihaga qarab, 3–6 oy",
                features: [
                    "Ko'p sotuvchili marketpleys yoki filial tarmog'i",
                    "Dilerlar uchun B2B kabinet va individual narx ro'yxatlari",
                    "ERP, ombor va buxgalteriya tizimlari bilan chuqur integratsiya",
                    "Mobil ilova (iOS va Android) umumiy API asosida",
                    "Tavsiya tizimi va shaxsiylashtirilgan katalog",
                    "Yuqori yuklama uchun infratuzilma: CDN, kesh, monitoring, zaxira",
                    "A/B testlash va konversiya optimizatsiyasi",
                    "Xavfsizlik auditi va kelishilgan SLA",
                ],
                best: "Marketpleys quruvchilar, ko'p filialli tarmoqlar va yuqori yuklamali loyihalar",
            },
        ],
    },
    process: {
        eyebrow: "Jarayon",
        h: "Internet do'kon qanday quriladi",
        sub: "Oltita bosqich. Har birining oxirida natijani ko'rasiz va yozma tasdiqlaysiz.",
        steps: [
            {
                t: "Tahlil va katalog tuzilmasi",
                d: "Assortimentni ko'rib chiqamiz, kategoriyalar, filtrlar va mahsulot xarakteristikalarini tuzamiz. Xarid yo'lini — katalogdan savatga, savatdan to'lovgacha — hujjat qilib belgilaymiz.",
                time: "3–5 kun",
            },
            {
                t: "Dizayn",
                d: "Figma'da bosh sahifa, katalog, mahsulot kartochkasi va savat chiziladi. Urg'u xarid yo'lini qisqartirishga beriladi: ortiqcha qadam har biri konversiyani kamaytiradi.",
                time: "7–12 kun",
            },
            {
                t: "Dasturlash",
                d: "Katalog, savat, buyurtma oqimi va admin panel quriladi. To'lov tizimlari, yetkazib berish qoidalari va Telegram bildirishnomalari ulanadi. Har hafta oraliq versiyani ko'rasiz.",
                time: "15–25 kun",
            },
            {
                t: "Mahsulotlarni yuklash",
                d: "Mahsulotlar Excel yoki 1C'dan ko'chiriladi, rasmlar siqiladi va bir o'lchamga keltiriladi, kategoriya matnlari yoziladi. Do'kon bo'sh emas, to'la holda topshiriladi.",
                time: "3–7 kun",
            },
            {
                t: "Sinov to'lovlari",
                d: "To'lov, bekor qilish, qaytarish va yetkazib berish oqimi haqiqiy tranzaksiyalarda sinovdan o'tkaziladi. Barcha qurilma va brauzerlar tekshiriladi, tezlik o'lchanadi.",
                time: "2–4 kun",
            },
            {
                t: "Ishga tushirish va o'qitish",
                d: "Domen ulanadi, analitika va e-commerce kuzatuvi sozlanadi, do'kon indeksatsiyaga yuboriladi. Jamoangizga admin panelni o'rgatamiz va video-qo'llanma beramiz.",
                time: "1–2 kun",
            },
        ],
    },
    samples: {
        eyebrow: "Namunalar",
        h: "Biz qurgan savdo saytlari",
        sub: "Har bir loyiha noldan qurilgan: katalog tuzilmasi, dizayn, matn va texnik qism bizning jamoamiz tomonidan tayyorlangan.",
        cta: "Barcha loyihalarni ko'rish",
        slugs: ["sts-market", "sbm-food", "bernhardt", "wogme"],
    },
    faq: {
        eyebrow: "Savol-javob",
        h: "Ko'p beriladigan savollar",
        sub: "Internet do'kon yaratish bo'yicha eng ko'p so'raladigan savollarga qisqa javoblar.",
        items: [
            {
                q: "Internet do'kon yaratish qancha turadi?",
                a: "Narxlar 16 000 000 so'mdan boshlanadi — bu to'liq ishlaydigan do'kon: katalog, savat, admin panel, Payme va Click to'lovlari, yetkazib berish sozlamalari va ikki tillilik. Individual dizayn, ombor hisobi, sodiqlik dasturi va 1C integratsiyasi bilan variant 34 000 000 so'mdan. Marketpleys yoki B2B kabinet kerak bo'lsa, narx loyihaga qarab hisoblanadi.",
            },
            {
                q: "Payme va Click'ni ulash narxga kiradimi?",
                a: "Ha, ulash, sozlash va sinov tranzaksiyalari narxga kiradi. Lekin to'lov tizimining o'z komissiyasi — ekvayring — alohida: u odatda tranzaksiyaning bir necha foizini tashkil qiladi va bevosita Payme yoki Click bilan tuzilgan shartnoma bo'yicha to'lanadi. Shartnomani rasmiylashtirishda yordam beramiz, bu odatda 3–7 kun oladi.",
            },
            {
                q: "Mahsulotlarni o'zim qo'sha olamanmi?",
                a: "Ha, admin panel barcha tariflarda bor. Mahsulot, narx, rasm, kategoriya va qoldiqni o'zingiz kiritasiz, buyurtmalarni panelda ko'rasiz va holatini o'zgartirasiz. Mahsulot ko'p bo'lsa, Excel yoki 1C'dan ommaviy yuklash ishlaydi — mingta pozitsiyani qo'lda kiritish shart emas. Panel o'zbek tilida bo'ladi va uni ishlatishni o'rganish odatda bir soat vaqt oladi.",
            },
            {
                q: "Uzum yoki Instagram o'rniga o'z do'konim kerakmi?",
                a: "Ular bir-birini almashtirmaydi, to'ldiradi. Marketpleys tez boshlash uchun yaxshi, lekin har sotuvdan komissiya oladi va mijoz bazasi sizniki bo'lmaydi. O'z do'koningiz — sizga tegishli aktiv: qayta sotuv, Google'dan bepul trafik va o'z qoidalaringiz. Ko'p mijozimiz ikkala kanalni birga olib boradi: marketpleysda yangi xaridor topadi, o'z do'konida esa uni doimiy mijozga aylantiradi.",
            },
            {
                q: "Do'kon necha kunda tayyor bo'ladi?",
                a: "Start tarifi 20–30 ish kunida, Business tarifi 40–60 ish kunida topshiriladi. Marketpleys darajasidagi loyihalar 3–6 oy oladi. Muddat assortiment hajmiga va mahsulot ma'lumotlari — rasm, tavsif, xarakteristika — qanchalik tayyorligiga bog'liq. Bular oldindan tayyor bo'lsa, jarayon 20–30 foizga tezlashadi. Mahsulot fotosuratlarini tayyorlash kerak bo'lsa, buni ham alohida kelishib olamiz.",
            },
            {
                q: "Do'kon Google'da chiqadimi?",
                a: "Do'kon qidiruvga tayyor holda topshiriladi: har bir mahsulot va kategoriya alohida manzil, to'g'ri meta teglar, Schema.org belgilash (narx, mavjudlik, reyting), sitemap va tezlik optimizatsiyasi. Bu Google Shopping va oddiy natijalarda ko'rinish uchun asos. Raqobatli so'rovlar uchun doimiy SEO ishi kerak — buni alohida xizmat sifatida olib boramiz.",
            },
            {
                q: "Yetkazib berish va kuryer xizmatini ulash mumkinmi?",
                a: "Ha. Bazaviy tarifda yetkazib berish usullari, hududlari va narxlarini sozlaymiz: masalan, Toshkent ichida bir narx, viloyatlarga boshqa narx. Business tarifida kuryer xizmatlari bilan integratsiya va buyurtma holatini kuzatish qo'shiladi — mijoz o'z buyurtmasi qayerdaligini ko'radi va qo'ng'iroq qilmaydi. Bepul yetkazib berish chegarasini ham belgilash mumkin.",
            },
            {
                q: "1C yoki CRM bilan bog'lash mumkinmi?",
                a: "Ha, Business va Enterprise tariflarida 1C yoki CRM bilan sinxronizatsiya bor: mahsulot, narx va qoldiq avtomatik yangilanadi, buyurtmalar esa tizimga tushadi. Bu qo'lda kiritishni butunlay olib tashlaydi va ombordagi qoldiq bilan saytdagi raqam farq qilib qolishining oldini oladi. Sinxronizatsiya odatda 15 daqiqada bir marta ishga tushadi.",
            },
            {
                q: "Keyinchalik mobil ilova qo'shsam bo'ladimi?",
                a: "Ha. Do'kon API asosida quriladi, shuning uchun mobil ilova mavjud tizim ustiga qo'shiladi: mahsulot va buyurtmalar bazasi bitta bo'lib qoladi. Biz iOS va Android ilovalarini ham ishlab chiqamiz. Odatda ilovaga o'tish do'kon ishga tushib, oyiga 300–500 buyurtma yig'ilgandan keyin mantiqli bo'ladi.",
            },
            {
                q: "Oylik to'lov yoki abonent to'lovi bormi?",
                a: "Bizga oylik platforma to'lovi to'lamaysiz — kod sizga tegishli. Doimiy xarajatlar faqat domen va hosting (yiliga taxminan 1,5–3 mln so'm, yuklamaga qarab) hamda to'lov tizimining ekvayring foizi. Olti oylik qo'llab-quvvatlash narxga kiradi; keyin xohlasangiz, oylik shartnoma tuzamiz. Shartnomasiz ham murojaat qilishingiz mumkin — bu holda ish soatbay hisoblanadi.",
            },
        ],
    },
    cta: {
        h: "Internet do'kon ochmoqchimisiz?",
        p: "Bepul konsultatsiyada assortimentingizni ko'rib chiqamiz, qaysi tarif yetarli ekanini aytamiz va aniq narx bilan muddatni belgilaymiz. Majburiyat yo'q.",
        button: "Bepul konsultatsiya olish",
        secondary: "+998 90 954 12 62",
    },
    images: [
        {
            src: "/assets/img/blog/ecom-cover.webp",
            alt: "Internet do'kon yaratish — onlayn magazin katalogi va savati ekranda",
            caption: "Internet do'kon katalog, savat va to'lovni bitta tizimga birlashtiradi.",
        },
        {
            src: "/assets/img/projects/sts-market.webp",
            alt: "STS Market internet do'koni — Innobek qurgan onlayn savdo sayti",
            caption: "STS Market — kategoriya filtri va onlayn to'lov bilan savdo sayti.",
        },
        {
            src: "/assets/img/blog/ecom-steps.webp",
            alt: "Internet do'kon ishlab chiqish bosqichlari — katalog, dizayn, to'lov va sinov",
            caption: "Oltita bosqich: katalog tuzilmasidan sinov to'lovlarigacha.",
        },
        {
            src: "/assets/img/blog/ecom-growth.webp",
            alt: "Onlayn do'kon sotuv statistikasi va konversiya ko'rsatkichlari grafigi",
            caption: "Analitika qaysi mahsulot sotilayotganini va savat qayerda tashlab ketilishini ko'rsatadi.",
        },
        {
            src: "/assets/img/projects/bernhardt.webp",
            alt: "Bernhardt onlayn do'koni — mahsulot kartochkasi va variatsiyalar bilan katalog",
            caption: "Bernhardt — variatsiyali mahsulotlar va individual dizayn bilan do'kon.",
        },
    ],
    related: ["korporativ-saytlar", "mobil-ilova", "telegram-bot", "seo", "crm-tizimlar"],
};

const ru = {
    meta: {
        title: "Создание интернет-магазина — цена от 16 млн сум | Innobek",
        description:
            "Создание интернет-магазина под ключ от 16 млн сум. Каталог, корзина, оплата Payme и Click, доставка и админ-панель. Срок 20–60 рабочих дней.",
        keywords: [
            "интернет-магазин",
            "создание интернет-магазина",
            "разработка интернет-магазина",
            "интернет-магазин цена",
            "онлайн-магазин",
            "сайт для продаж",
            "подключить Payme Click",
            "интернет-магазин под ключ",
            "интернет-магазин Ташкент",
        ],
    },
    hero: {
        eyebrow: "Интернет-магазины",
        h1: "Создание интернет-магазина — от 16 млн сум",
        lead:
            "Перестаньте собирать заказы в комментариях Instagram. Собственный интернет-магазин продаёт круглосуточно: каталог, корзина, оплата через Payme и Click, доставка и учёт заказов — всё в одной системе и под вашим контролем.",
        ctaPrimary: "Получить бесплатную консультацию",
        ctaSecondary: "Посмотреть цены",
        proof: [
            "Payme · Click · Uzum",
            "Админ-панель в каждом тарифе",
            "Импорт товаров из Excel и 1С",
            "6 месяцев техподдержки",
        ],
    },
    intro: {
        h: "Что такое интернет-магазин и чем он выгоднее маркетплейса?",
        p: [
            "Интернет-магазин — это сайт, где объединены каталог товаров, корзина, онлайн-оплата и система управления заказами. Клиент находит товар, кладёт его в корзину, оплачивает картой и выбирает способ доставки. Всё это происходит без переписки с вами — хоть в два часа ночи. Заказ попадает в админ-панель, а уведомление приходит в Telegram.",
            "Сегодня многие предприниматели продают через Instagram или маркетплейс. Для старта это нормально, но есть три проблемы: каждый заказ приходится вести вручную, с каждой продажи удерживается комиссия и, главное, база клиентов принадлежит не вам. Если платформа завтра изменит правила или стоимость продвижения, повлиять на это вы не сможете.",
            "Собственный интернет-магазин — это ваш актив: данные клиентов, статистика продаж, возможность повторных продаж и бесплатный трафик из Google. Магазин принимает десятки заказов в час с одинаковым качеством, а сотрудник вместо переписки занимается сборкой и доставкой. Чем выше оборот, тем заметнее эта разница: при ручном учёте число ошибок и потерянных заказов растёт вместе с объёмом, а в системе остаётся прежним.",
            "Innobek делает магазин под рынок Узбекистана: оплата Payme, Click и Uzum, доставка курьером и почтой, уведомления в Telegram, каталог на двух или трёх языках. Товары переносим из Excel или 1С — мы не сдаём пустой сайт с нулевым каталогом. Код принадлежит вам, ежемесячной платы за платформу нет.",
        ],
    },
    definition: {
        term: "Что такое интернет-магазин?",
        text:
            "Интернет-магазин — это сайт, объединяющий каталог товаров, корзину, онлайн-оплату, доставку и управление заказами. Он принимает заказы в любое время суток без участия продавца.",
    },
    included: {
        eyebrow: "Что входит",
        h: "Входит в каждый тариф по умолчанию",
        sub: "Это не платные дополнения — всё есть даже в базовом тарифе.",
        items: [
            "Бесплатная консультация, структура каталога и письменное техзадание",
            "Каталог товаров с категориями, фильтрами и поиском",
            "Корзина, оформление заказа и история заказов",
            "Админ-панель: товары, цены, остатки и заказы",
            "Подключение и тестирование Payme и Click",
            "Оплата наличными и картой курьеру",
            "Настройка способов, зон и стоимости доставки",
            "Домен, хостинг, SSL-сертификат и защищённый платёжный поток",
            "Адаптивный дизайн, проверенный на телефоне и планшете",
            "Schema.org для карточек товара: цена, наличие, рейтинг",
            "Google Analytics и отслеживание электронной коммерции",
            "Оптимизация скорости: сжатие изображений, lazy-load, кеширование",
            "Видеоинструкция по управлению магазином и встреча-передача",
            "6 месяцев технической поддержки после запуска",
        ],
    },
    benefits: {
        eyebrow: "Зачем нужен",
        h: "Что интернет-магазин даёт бизнесу",
        sub: "Магазин — не расход, а ваш второй продавец. Ниже — на что он влияет конкретно.",
        items: [
            {
                t: "Продажи идут, пока вы спите",
                d: "Заказы принимаются ночью, в выходные и в праздники. Клиент не ждёт ответа: оплатил и сразу получил подтверждение. На практике 20–30 процентов заказов приходят вне рабочего времени.",
            },
            {
                t: "Вы не платите комиссию с каждой продажи",
                d: "Маркетплейс обычно удерживает заметную долю с каждой продажи. В своём магазине остаётся только процент эквайринга. При обороте от 50 млн сум в месяц экономия окупает магазин примерно за год.",
            },
            {
                t: "База клиентов остаётся у вас",
                d: "Телефон, история заказов и адрес хранятся в вашей системе. Это основа для повторных продаж, рассылок в SMS и Telegram и программы лояльности. Привлечь нового покупателя всегда дороже, чем вернуть уже существующего.",
            },
            {
                t: "Ручная работа исчезает",
                d: "Заказ фиксируется сам, остаток списывается сам, подтверждение уходит клиенту автоматически. Один сотрудник ведёт без ошибок не 10, а 100 заказов в день.",
            },
            {
                t: "Бесплатный трафик из Google",
                d: "Каждый товар и категория — отдельная страница под запросы вроде «зимняя куртка цена». Грамотно собранный каталог через 3–6 месяцев начинает давать трафик без рекламы.",
            },
            {
                t: "Решения по цифрам",
                d: "Аналитика показывает, какой товар часто смотрят, но не покупают, какой канал привёл заявку, на каком шаге бросают корзину. Ассортимент и реклама настраиваются по этим данным.",
            },
            {
                t: "Независимость от маркетплейса",
                d: "Если платформа изменит правила или понизит вашу карточку в выдаче, продажи могут упасть за одну ночь. Собственный магазин работает по вашим правилам и не зависит от чужого алгоритма.",
            },
        ],
    },
    audience: {
        eyebrow: "Кто заказывает",
        h: "Какому бизнесу нужен интернет-магазин",
        sub: "Сферы с повторяющимися продажами, где вести заказы вручную уже тяжело.",
        items: [
            {
                t: "Одежда и обувь",
                d: "Фильтры по размеру, цвету и модели, размерная сетка, условия возврата. Клиент выбирает сам и оформляет заказ без вопросов — обращений к продавцу становится меньше примерно на 60 процентов.",
            },
            {
                t: "Электроника и бытовая техника",
                d: "Подробные характеристики, сравнение товаров, условия гарантии и рассрочка. В этой сфере покупателю важнее всего полная и точная информация.",
            },
            {
                t: "Косметика, парфюмерия и БАДы",
                d: "Состав, сертификаты, правила применения и отзывы. Повторных покупок здесь много, поэтому программа лояльности и кнопка повторного заказа окупаются быстро.",
            },
            {
                t: "Продукты питания и доставка",
                d: "Каталог по категориям, временные окна доставки, минимальная сумма заказа и повтор заказа в одно нажатие. Скорость напрямую влияет на конверсию.",
            },
            {
                t: "Мебель, стройматериалы и оборудование",
                d: "Большой каталог, калькулятор расхода материалов, заказ по размерам и услуга монтажа. Часто модуль калькулятора разрабатывается отдельно.",
            },
            {
                t: "B2B и оптовая торговля",
                d: "Личный кабинет дилера, индивидуальные прайс-листы, минимальная партия, счета и интеграция с 1С. Менеджеры работают с системой, а не с телефоном.",
            },
        ],
    },
    pricing: {
        eyebrow: "Цены",
        h: "Стоимость интернет-магазина — три тарифа",
        sub: "Цены открытые. В каждый тариф входят админ-панель, платёжные системы, языки и поддержка.",
        note:
            "Указанные суммы — стартовый диапазон. Итоговая цена подтверждается после бесплатной консультации и зависит от числа товаров, вариаций и интеграций. Оплата поэтапная: 50% предоплата, 50% при сдаче. Комиссия эквайринга оплачивается напрямую Payme или Click и в стоимость не входит.",
        tiers: [
            {
                name: "Старт",
                tagline: "Полноценно работающий интернет-магазин",
                price: "16 000 000",
                priceNote: "сум — в зависимости от проекта",
                term: "20–30 рабочих дней",
                features: [
                    "До 500 товаров, каталог с категориями и фильтрами",
                    "Корзина, оформление заказа и история заказов",
                    "Админ-панель: товары, цены, категории и заказы",
                    "Онлайн-оплата Payme и Click, наличные и карта курьеру",
                    "Настройка способов и стоимости доставки",
                    "Двуязычный интерфейс (узбекский и русский)",
                    "Уведомления о новых заказах в Telegram",
                    "Дизайн на готовой основе с адаптацией под ваш бренд",
                    "Техническое SEO и разметка товаров Schema.org",
                    "Массовая загрузка товаров из Excel",
                    "6 месяцев технической поддержки",
                ],
                best: "Продавцам, которые переходят из Instagram или с маркетплейса в свой магазин",
            },
            {
                name: "Бизнес",
                tagline: "Индивидуальный дизайн и полное управление",
                price: "34 000 000",
                priceNote: "сум — в зависимости от проекта",
                term: "40–60 рабочих дней",
                features: [
                    "Неограниченное число товаров, сложное дерево категорий",
                    "Индивидуальный дизайн с нуля, с макетом в Figma",
                    "Товары с вариациями: размер, цвет, комплектация",
                    "Расширенная админ-панель: остатки, поставщики, отчёты",
                    "Акции, скидки, промокоды и программа лояльности",
                    "Личный кабинет клиента: заказы, адреса, избранное",
                    "Uzum, Payme, Click и сервисы рассрочки",
                    "Интеграция со службами доставки и отслеживание заказа",
                    "Синхронизация с 1С или CRM",
                    "Отзывы и рейтинги, напоминание о брошенной корзине",
                    "Расширенное SEO: тексты категорий, перелинковка, скорость",
                    "Аналитика продаж и цели по конверсии",
                    "6 месяцев технической поддержки",
                ],
                best: "Магазинам с большим ассортиментом, складским учётом и постоянным маркетингом",
                featured: true,
            },
            {
                name: "Enterprise",
                tagline: "Маркетплейс и сложные интеграции",
                price: "По договору",
                priceNote: "— от 70 млн сум",
                term: "По проекту, 3–6 месяцев",
                features: [
                    "Маркетплейс с несколькими продавцами или сеть филиалов",
                    "B2B-кабинет для дилеров и индивидуальные прайс-листы",
                    "Глубокая интеграция с ERP, складом и бухгалтерией",
                    "Мобильное приложение (iOS и Android) на общем API",
                    "Рекомендательная система и персонализированный каталог",
                    "Инфраструктура под нагрузку: CDN, кеш, мониторинг, резервные копии",
                    "A/B-тестирование и оптимизация конверсии",
                    "Аудит безопасности и согласованный SLA",
                ],
                best: "Тем, кто строит маркетплейс, сетям филиалов и высоконагруженным проектам",
            },
        ],
    },
    process: {
        eyebrow: "Процесс",
        h: "Как создаётся интернет-магазин",
        sub: "Шесть этапов. В конце каждого вы видите результат и подтверждаете его письменно.",
        steps: [
            {
                t: "Анализ и структура каталога",
                d: "Разбираем ассортимент, собираем категории, фильтры и характеристики товаров. Документально фиксируем путь покупки — от каталога к корзине и от корзины к оплате.",
                time: "3–5 дней",
            },
            {
                t: "Дизайн",
                d: "Рисуем в Figma главную, каталог, карточку товара и корзину. Упор на сокращение пути покупки: каждый лишний шаг снижает конверсию.",
                time: "7–12 дней",
            },
            {
                t: "Разработка",
                d: "Собираем каталог, корзину, поток заказа и админ-панель. Подключаем платёжные системы, правила доставки и уведомления в Telegram. Промежуточную версию вы видите каждую неделю.",
                time: "15–25 дней",
            },
            {
                t: "Загрузка товаров",
                d: "Переносим товары из Excel или 1С, сжимаем и приводим изображения к единому формату, пишем тексты категорий. Магазин сдаётся наполненным, а не пустым.",
                time: "3–7 дней",
            },
            {
                t: "Тестовые оплаты",
                d: "Проверяем оплату, отмену, возврат и доставку на реальных транзакциях. Тестируем во всех браузерах и на всех устройствах, замеряем скорость загрузки.",
                time: "2–4 дня",
            },
            {
                t: "Запуск и обучение",
                d: "Подключаем домен, настраиваем аналитику и электронную коммерцию, отправляем магазин на индексацию. Обучаем вашу команду работе с админ-панелью и выдаём видеоинструкцию.",
                time: "1–2 дня",
            },
        ],
    },
    samples: {
        eyebrow: "Примеры",
        h: "Магазины, которые мы сделали",
        sub: "Каждый проект собран с нуля: структура каталога, дизайн, тексты и разработка — работа нашей команды.",
        cta: "Смотреть все проекты",
        slugs: ["sts-market", "sbm-food", "bernhardt", "wogme"],
    },
    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы",
        sub: "Короткие ответы на самые частые вопросы о создании интернет-магазина.",
        items: [
            {
                q: "Сколько стоит создание интернет-магазина?",
                a: "Цены начинаются от 16 000 000 сум — это полностью работающий магазин: каталог, корзина, админ-панель, оплата Payme и Click, настройка доставки и два языка. Вариант с индивидуальным дизайном, складским учётом, программой лояльности и интеграцией с 1С — от 34 000 000 сум. Для маркетплейса или B2B-кабинета цена считается по проекту.",
            },
            {
                q: "Подключение Payme и Click входит в стоимость?",
                a: "Да, подключение, настройка и тестовые транзакции входят в стоимость. Но собственная комиссия платёжной системы — эквайринг — оплачивается отдельно: обычно это несколько процентов от транзакции по прямому договору с Payme или Click. С оформлением договора помогаем, обычно это занимает 3–7 дней.",
            },
            {
                q: "Смогу ли я сам добавлять товары?",
                a: "Да, админ-панель есть во всех тарифах. Вы вносите товары, цены, изображения, категории и остатки, видите заказы в панели и меняете их статус. Если товаров много, работает массовая загрузка из Excel или 1С — вручную забивать тысячу позиций не придётся. Панель на русском языке, освоение обычно занимает около часа.",
            },
            {
                q: "Нужен ли свой магазин, если есть Uzum или Instagram?",
                a: "Они друг друга не заменяют, а дополняют. Маркетплейс хорош для быстрого старта, но берёт комиссию с каждой продажи, и база клиентов остаётся не у вас. Свой магазин — это ваш актив: повторные продажи, бесплатный трафик из Google и собственные правила. Многие наши клиенты ведут оба канала: на маркетплейсе находят нового покупателя, а в своём магазине делают его постоянным.",
            },
            {
                q: "За сколько дней будет готов магазин?",
                a: "Тариф Старт сдаём за 20–30 рабочих дней, тариф Бизнес — за 40–60 рабочих дней. Проекты уровня маркетплейса занимают 3–6 месяцев. Срок зависит от объёма ассортимента и готовности данных о товарах — фотографий, описаний, характеристик. С готовыми данными процесс ускоряется на 20–30 процентов.",
            },
            {
                q: "Будет ли магазин виден в Google?",
                a: "Магазин сдаётся подготовленным к поиску: у каждого товара и категории свой адрес, корректные мета-теги, разметка Schema.org (цена, наличие, рейтинг), sitemap и оптимизация скорости. Это база для показа в обычной выдаче и Google Shopping. Для конкурентных запросов нужна постоянная SEO-работа — ведём её отдельной услугой.",
            },
            {
                q: "Можно ли подключить доставку и курьерские службы?",
                a: "Да. В базовом тарифе настраиваем способы, зоны и стоимость доставки: например, одна цена по Ташкенту и другая по регионам. В тарифе Бизнес добавляются интеграция со службами доставки и отслеживание статуса — клиент сам видит, где его заказ, и не звонит менеджеру.",
            },
            {
                q: "Можно ли связать магазин с 1С или CRM?",
                a: "Да, в тарифах Бизнес и Enterprise есть синхронизация с 1С или CRM: товары, цены и остатки обновляются автоматически, а заказы попадают в систему. Это полностью убирает ручной ввод и не даёт разойтись цифрам на складе и на сайте. Синхронизация обычно запускается раз в 15 минут.",
            },
            {
                q: "Можно ли позже добавить мобильное приложение?",
                a: "Да. Магазин строится на API, поэтому мобильное приложение надстраивается над существующей системой: база товаров и заказов остаётся общей. Мы разрабатываем приложения для iOS и Android. Обычно переход к приложению имеет смысл, когда магазин уже даёт 300–500 заказов в месяц и появляются постоянные покупатели.",
            },
            {
                q: "Есть ли ежемесячная или абонентская плата?",
                a: "Нам вы не платите ежемесячно за платформу — код принадлежит вам. Постоянные расходы — это только домен и хостинг (примерно 1,5–3 млн сум в год в зависимости от нагрузки) и процент эквайринга. Шесть месяцев поддержки входят в стоимость; дальше при желании заключаем договор на обслуживание.",
            },
        ],
    },
    cta: {
        h: "Хотите открыть интернет-магазин?",
        p: "На бесплатной консультации разберём ваш ассортимент, скажем, какого тарифа достаточно, и зафиксируем точную цену и срок. Без обязательств.",
        button: "Получить бесплатную консультацию",
        secondary: "+998 90 954 12 62",
    },
    images: [
        {
            src: "/assets/img/blog/ecom-cover.webp",
            alt: "Создание интернет-магазина — каталог и корзина интернет-магазина на экране",
            caption: "Интернет-магазин объединяет каталог, корзину и оплату в одной системе.",
        },
        {
            src: "/assets/img/projects/sts-market.webp",
            alt: "Интернет-магазин STS Market — сайт онлайн-продаж, разработанный Innobek",
            caption: "STS Market — торговый сайт с фильтрами по категориям и онлайн-оплатой.",
        },
        {
            src: "/assets/img/blog/ecom-steps.webp",
            alt: "Этапы разработки интернет-магазина — каталог, дизайн, оплата и тестирование",
            caption: "Шесть этапов: от структуры каталога до тестовых оплат.",
        },
        {
            src: "/assets/img/blog/ecom-growth.webp",
            alt: "График статистики продаж и конверсии интернет-магазина в аналитике",
            caption: "Аналитика показывает, что продаётся и на каком шаге бросают корзину.",
        },
        {
            src: "/assets/img/projects/bernhardt.webp",
            alt: "Интернет-магазин Bernhardt — карточка товара и каталог с вариациями",
            caption: "Bernhardt — магазин с вариациями товаров и индивидуальным дизайном.",
        },
    ],
    related: ["korporativ-saytlar", "mobil-ilova", "telegram-bot", "seo", "crm-tizimlar"],
};

const content = { uz, ru };

export default content;
